export const ADD_VISA_AND_STUDY_PERMIT_STARTED =
  'ADD_VISA_AND_STUDY_PERMIT_STARTED';
export const ADD_VISA_AND_STUDY_PERMIT_SUCCESS =
  'ADD_VISA_AND_STUDY_PERMIT_SUCCESS';
export const ADD_VISA_AND_STUDY_PERMIT_ENDED = 'ADD_VISA_AND_STUDY_PERMIT_ENDED';
export const ADD_VISA_AND_STUDY_PERMIT_ERROR = 'ADD_VISA_AND_STUDY_PERMIT_ERROR';
